// NOTE: Avoiding using mixins for code reuse as Vue 3 recommends using new Composition API over mixins
import dayjs from "@/plugins/dayjs";

export const parseDatetimeStr = val => {
  if (val) return dayjs(val);
  return dayjs();
};
